/**
 * Reads the expense totals/comparison the backend now computes per scheda
 * (scheda.comparazioneList), instead of recomputing it client-side.
 * @param {Object} scheda - The scheda object returned by the API
 */
export const useExpencers = (scheda) => {
  const comparazione = scheda?.comparazioneList;

  return {
    expencersWithTotals: comparazione?.expencersWithTotals || [],
    maxExpencer: comparazione?.maxExpencer || null,
    expencersDiff: comparazione?.expencersDiff || [],
  };
};

export default useExpencers;
